define('features/vehicle-info/vehicle-info.prius-prime',[
  'jquery',
  'txt!./vehicle.benefits.hbs',
  './vehicle-benefits',
  'disclaimers',
  'lib/util/zip',
  'cookies',
  'zipTools',
  'lib/util/tda.config',
  'lib/util/langFromUrl',
  'bat',
  'lib/page-cache',
  'lib/scroller',
  'lib/analytics/blocks/index',
  'lib/analytics/pageload',
  'lib/analytics/click',
  'lib/analytics/context.add',

  // side effect includes
  'lib/helpers/replaceDisclaimer',
  'lib/helpers/replace'
], function (
  $,
  txtBenefits,
  VehicleBenefits,
  disclaimers,
  zip,
  cookies,
  zipTools,
  tdaConfig,
  langFromUrl,
  bat,
  PageCache,
  scroller,
  blocks,
  anPageLoad,
  anClicks,
  anAddContext
) {
  var __tmplBenefits = Handlebars.compile(txtBenefits);
  var __vehicleBenefits = new VehicleBenefits();
  return {
    staticDisclaimers: [
      // 'chargepoint',
      'incentives',
      'prime_calculations',
      'prime_hybrid_caution',
      'prime_gas',
      'prime_tco_doesource',
      'prime_2018_ev_range',
      'prime_2018_range_rating'
    ],

    showSideBarLinks: function () {
      if ($('#vehicleBenefits').attr('vehicleBenefits') === 'true') {
        $('#benefitsCalculatorLink').show();
        $('#benefitsLink').show();
        $('.vehicle-info-benefits').show();
      }
    },

    buildCalculator: function () {
      var self = this;
      __vehicleBenefits.init();
      __vehicleBenefits.getContent('PriusPrimeIncentives')
        .then(function (response) {
          var benefitObj = {
            federal: response.national,
            state: response.state
          };
          __vehicleBenefits.getContent('PriusPrimeMLP')
            .then(function (res) {
              self.draw(res, benefitObj);
            });
        });
    },

    analytics: function () {
      var $scope = $('#section-info-calculator');
      anAddContext(
        $scope,
        blocks.sectionBlock('Benefits'),
        blocks.seriesBlock({
          series_code: 'priusprime',
          year: '2018'
        })
      );
      anClicks($scope);

      scroller.add($scope, {
        after: function () {
          anPageLoad($scope);
        }
      });

    },

    draw: function (res, benefitObj) {
      var self = this;
      benefitObj.tco = res.tco;
      var benefitsHtml = __tmplBenefits({ benefits: benefitObj });
      var zipCode = zip.getCookiedDefaultFallback();
      $('#js-template-benefits-output').html(benefitsHtml);

      PageCache.await('vehicle.info.localDisclaimers')
        .then(function () {
          disclaimers.updateBenefitsDisclaimers('#template-benefits');
          self.analytics();
        });

      if (__vehicleBenefits.noStateDetected) {
        $('.tco-incentive-card.row.tco-incentive-card.state').find('.sub-title').addClass('no-state');
        $('.tco-incentive-card.row.tco-incentive-card.state').find('.pre-title').hide();
      }

      if (tdaConfig.tda.code === 'WWW') {
        $('.location-based span').text('...');
        var ctaText = langFromUrl() === 'en' ? 'Set Your Location' : 'Establece tu ubicaci&#x00F3;n';
        var linkString = '<a id="locationChange" class="location-change js-nav-zip" href="#location">' + ctaText + '</a>';

        setTimeout(function () {
          $('.location-based span').html(linkString);
          $('#locationChange').on('click', function (e) {
            var redirectHref = window.location.pathname;
            e.preventDefault();
            zipTools.showPromptUserZipModal(zipCode, zipCode, redirectHref, '', true, true);
          });
        }, 2000);
      } else {
        $('#locationChange').text(zipCode).on('click', function (e) {
          e.preventDefault();
          var redirectHref = window.location.pathname;
          zipTools.showPromptUserZipModal(zipCode, zipCode, redirectHref, '', true, true);
        });
      }

      $('#distanceCalcForm').h5Validate();
      $('#stateIncentives, #benefitsLink').on('click', function (e) {
        e.preventDefault();
        disclaimers.updateBenefitsDisclaimers('#template-benefits');
        $('#modal-benefits').modal('show');
      });

      $('#benefitsCalcSubmit').on('click', function (e) {
        e.preventDefault();
        bat.util.loader.showLoader();
        var startVal = $('#homeAddress').val(); // 'Dedham Parkway, Boston, MA 02026, United States';
        var endVal = $('#workAddress').val(); // '1605 VFW Parkway Boston, MA 02132';

        var handleDistanceResponse = function (response, responseStatus) {
          bat.util.loader.hideLoader(null, true, 250);
          var rowStatus = response.rows[0].elements[0].status;
          if (responseStatus === 'OK' && (!/NOT_FOUND|ZERO_RESULTS/.test(rowStatus))) {
            var distance = response.rows[0].elements[0].distance.value * 0.00062137;
            distance = distance.toString();
            var tomorrow = new Date((new Date()).valueOf() + 1000 * 3600 * 24);
            cookies.setItem('benfitsStartAddress', startVal, tomorrow, '/', zipTools.getCrossDomainCookieDomain());
            cookies.setItem('benfitsEndAddress', endVal, tomorrow, '/', zipTools.getCrossDomainCookieDomain());
            cookies.setItem('benfitsTripDistance', distance, tomorrow, '/', zipTools.getCrossDomainCookieDomain());
            var calcPath = '/' + tdaConfig.site.context_url + '/vehicles/priusprime/calculator';
            window.location.href = calcPath;
          } else {
            // When status is OK, but there are no results...
            $('#homeAddress').val('');
            $('#workAddress').val('');
            $('.address-error').show();
            $('#benefitsCalcSubmit').hide();
          }
        };
        __vehicleBenefits.requestDistance(startVal, endVal, handleDistanceResponse);
      });

      $('#homeAddress, #workAddress').keyup(function () {
        $('.address-error').hide();
        $('#benefitsCalcSubmit').show();
        var valid = $('#distanceCalcForm').h5Validate('allValid');
        if (valid) {
          $('#benefitsCalcSubmit').removeClass('disabled');
        } else {
          $('#benefitsCalcSubmit').addClass('disabled');
        }
      });

      if (cookies.getItem('benfitsStartAddress')) {
        if (cookies.getItem('benfitsStartAddress')) {
          $('#homeAddress').val(cookies.getItem('benfitsStartAddress'));
          $('#workAddress').val(cookies.getItem('benfitsEndAddress'));
          $('#benefitsCalcSubmit').removeClass('disabled');
        }
      }

      __vehicleBenefits.createBenefitsModal();
    }
  };
});

